





















import Vue from 'vue';
import ServiceType from '../service/service-type';
import { AccountService } from '../types';

export default Vue.extend({
  props: {
    value: {
      type: Array as () => AccountService[],
      default() {
        return [];
      },
    },
  },
  computed: {
    services() {
      return this.value
        .filter(accountService => accountService.service.type === ServiceType.CORE)
        .map(accountService => accountService.service.name);
    },
  },
});
